/**
 * NativeWind setup for third-party components
 * This file configures className support for components that don't natively support it
 */
import { cssInterop } from 'nativewind';
import Animated from 'react-native-reanimated';

// Make Animated components from reanimated work with NativeWind className
cssInterop(Animated.View, { className: 'style' });
cssInterop(Animated.Text, { className: 'style' });
cssInterop(Animated.Image, { className: 'style' });
cssInterop(Animated.ScrollView, { className: 'style', contentContainerClassName: 'contentContainerStyle' });

export {};
